import Vue from 'vue';
import App from './App.vue';
import './assets/icon/iconfont.css';

import VueI18n from 'vue-i18n';
import store from './store';
import Toast from './components/message/Toast';
import './permission';
import { getSessionStorage } from '@/utils/stage';
// import './utils/init'
import VConsole from 'vconsole/dist/vconsole.min.js';
// process.env
if (
	window.location.href.indexOf('fungoImg') > -1 ||
	window.location.href.indexOf('17atv') > -1
) {
	let vConsole = new VConsole();
}
Vue.prototype.$vconsole = VConsole;
Vue.prototype.$toast = Toast;
Vue.use(VueI18n);
import router from './router';
const i18n = new VueI18n({
	locale: getSessionStorage('lang') ? getSessionStorage('lang') : 'zh-cn', // 语言标识
	messages: {
		'zh-cn': require('./assets/lang/zh-cn'),
		en: require('./assets/lang/en'),
		'zh-tw': require('./assets/lang/zh-tw'),
		'ko-kr': require('./assets/lang/ko-kr'),
		'en-us': require('./assets/lang/en-us'),
		'ja-jp': require('./assets/lang/ja-jp'),
	},
});
Vue.config.productionTip = false;
new Vue({
	router,
	store,
	i18n,
	render: (h) => h(App),
}).$mount('#app');
